'use strict';

import {SocketConnector} from '../support_connectors/base_connector/socket_connector';

/**
 * JackpotConnector class.
 *
 * Allow watch jackpot changed
 * 
 * @inheritDoc
 */
    
export default class JackpotConnector extends SocketConnector {

    constructor(socket) {
        super(socket);
        this.verbose_name = "JackpotConnector:";
        this.controller_id = "jackpot-rpc";

        this.cb_jp_changed = (data)  =>  {this.__log("cb_jp_changed not used", data) };
        this.model = {
            "enabled" : false,             // включены ли джекпоты
            "values" : [0, 0, 0, 0],       // значения               
            'credit_price': 100,           // цена одного кредита WBG
            "conditions": [0,0,2000,5000], // минимальная ставка  для получения джекпота
            "currency": {                  // валюта
                id: 645,
                code_name: "RUB",
                minor_units: 2,                
            },
            "details": [                   // детально по каждому джекпоту
                {
                    "id" : 1,
                    "value" : 24235,
                    "type_id": 6
                },
                {
                    "id" : 2,
                    "value" : 24235,
                    "type_id": 6
                },
                {
                    "id" : 3,
                    "value" : 24235,
                    "type_id": 6
                },
                {
                    "id" : 4,
                    "value" : 24235,
                    "type_id": 6
                },
            ]
        };
        this.__setupCallbacks();
    }
    
    __setupCallbacks() {        
        this.socket.on("jp_changed_all", (data) => {
            this.model = data;
            this.cb_jp_changed(data);            
        });

        this.socket.on("connect", () => {            
            this.doViewAll().then( data => {
                this.model = data;
                this.cb_jp_changed(data);
                this.__watchJackpots();                                
            }).catch( (e) => {
                // jackpot not supported  on non wbg
                console.warn(e);
            })                           
        })

        this.socket.on("jackpotChanged", ({id, value}) => {
            this.__updateJp(id, value);
            this.cb_jp_changed(this.model);
        })
    }

    __updateJp(id,value) {
        if(!this.model.details)
            return;

        let jp_index = this.model.details.findIndex(element => element.id == id );
        if(jp_index < 0) // not found
            return;                
        this.model.details[jp_index].value = value
        this.model.values[jp_index] = value;                        
    }
    __watchJackpots()  {        
        if(!this.model.details)
            return;

        this.model.details.forEach(element => {
            let id = element.id
            this.__watchJackpot(id);
        });        
    }

    __watchJackpot(id)  {        
        this.socket.emit( "watchJackpot" , {
            jp_id: id            
        });
    }

    doViewAll() {        
        return this.__callPromise("view-jackpot-all", {});
    }    
}


// WEBPACK FOOTER //
// ./src/library/minigame_client/common/JackpotConnector.es6